import { Component, EventEmitter, Input, OnInit, Output, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { FileThumbObj, FileThumbType } from 'src/app/models/Lookup';

@Component({
  selector: 'app-video-manager',
  templateUrl: './video-manager.component.html',
})
export class VideoManagerComponent implements OnInit {
  @Output() selectedFiles = new EventEmitter<[]>();
  @Output() deletedFilesList = new EventEmitter<[]>();

  @Input() files: any = [];
  @Input() docsEditable = true;
  @Input() maxFiles = 5;
  @Input() maxFileSize = 10;
  @Input() managerIndex: any = '0'; // For input id multi file manager in one view
  @Input() label!: string;
  @Input() isRequired = false;
  @Input() isSubmitted = false;
  @Input() isDisabled = false;
  @Input() cols = 1;

  @Input() allowedExt: any[] = ['mp4', 'mpg'];

  /////
  selectedfilesCount = 0;
  deletedFiles: any = [];
  validFile = true;
  fileMaxSiZeErorr = false;
  fileMaxNameSiZeErorr = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private translate: TranslateService
  ) { }

  ngOnInit() { }

  validFileType(fileName: string) {
    const extension = fileName.split('.').pop()?.toLowerCase();
    const extensionUpper = fileName.split('.').pop()?.toUpperCase();

    if (!(this.allowedExt.includes(extension) || this.allowedExt.includes(extensionUpper))) {
      return false;
    }
    return true;
  }
  fileExt(fileName: string) {
    const extension = fileName.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'mp4':
      case 'mpg':
        return 'video';
      default:
        return false;
    }
  }

  /**
   * on file drop handler
   */
  onFileDropped($event: any) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event: any) {
    this.prepareFilesList(event.target.files);
    event.target.value = '';
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number, id: any) {
    if (id) {
      this.deletedFiles.push(id);
    }
    this.files.splice(index, 1);

    this.selectedFiles.emit(this.files);
    this.deletedFilesList.emit(this.deletedFiles);

    this.selectedfilesCount = this.files.length;
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    this.validFile = true;
    this.selectedfilesCount = this.files.length + files.length;
    if (this.selectedfilesCount > this.maxFiles) {
      return;
    }
    for (const item of files) {
      if (this.validFileType(item.name)) {
        this.validFile = true;
      } else {
        this.validFile = false;
      }

      // Check file and push to array files
      if (item.size / (1024 * 1024) <= this.maxFileSize && this.validFileType(item.name)) {
        item.fileType = this.fileExt(item.name);

        let fileObj = {
          file: item,
          thumbStr: '',
          thumb: null,
          thumbType: FileThumbType.Generated
        } as FileThumbObj;
        this.generateThumbnail(item).then(thumb => {
          fileObj.thumbStr = thumb
          fileObj.thumb = this.dataURItoBlob(thumb)
        });

        this.files.push(fileObj);
        this.selectedFiles.emit(this.files);

        if (item.size / (1024 * 1024) <= this.maxFileSize) {
          this.fileMaxSiZeErorr = false;
        }
      } else {
        if (item.size / (1024 * 1024) > this.maxFileSize) {
          this.fileMaxSiZeErorr = true;
        }
      }
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  public generateThumbnail(videoFile: Blob): Promise<string> {
    const video: HTMLVideoElement = this.document.createElement('video');
    const canvas: HTMLCanvasElement = this.document.createElement('canvas');
    const context: CanvasRenderingContext2D | null = canvas.getContext('2d');
    return new Promise<string>((resolve, reject) => {
      canvas.addEventListener('error',  reject);
      video.addEventListener('error',  reject);
      video.addEventListener('canplay', event => {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context?.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        resolve(canvas.toDataURL('image/jpeg'));
      });
      if (videoFile.type) {
        video.setAttribute('type', videoFile.type);
      }
      video.preload = 'auto';
      video.src = window.URL.createObjectURL(videoFile);
      video.load();
    });
  }

  dataURItoBlob(dataURI: string) {
    dataURI = dataURI.replace('data:image/jpeg;base64,', '');
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    const imageBlob: Blob = blob;
    const imageName: string = "thumb.jpeg";
    const imageFile: File = new File([imageBlob], imageName, {
      type: "image/jpeg"
    });
    return imageFile;
  }
  // dataURItoBlob(dataURI: string): Observable<Blob> {
  //   return Observable.create((observer: Observer<Blob>) => {
  //     const byteString: string = window.atob(dataURI);
  //     const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteString.length);
  //     const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
  //     for (let i = 0; i < byteString.length; i++) {
  //       int8Array[i] = byteString.charCodeAt(i);
  //     }
  //     const blob = new Blob([int8Array], { type: "image/jpeg" });
  //     observer.next(blob);
  //     observer.complete();
  //   });
  // }


  //////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////

  // File preview with validation
  changeThumbListener($event: any, index: number): void {
    const file: File = $event.target.files[0];
    if (file && this.validateFile(file, index)) {
      this.readThis(file, index);
      this.files[index].thumb = file;
      this.files[index].thumbType = FileThumbType.Uploaded;
    }
  }
  readThis(file: File, index: number): void {
    const myReader: FileReader = new FileReader();
    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      this.files[index].thumbStr = myReader.result as string;
    };
  }
  validateFile(file: File, index: number): any {
    if (this.fileType(file.name)) {
      // this.fileTypeError = false;
      if ((file.size / (1024 * 1024)) <= 1) {
        // this.fileSizeError = false;
      } else {
        // this.fileSizeError = true;
        Swal.fire({
          icon: 'error',
          text: this.translate.instant('forms.Max-file-size') + ' 1' + this.translate.instant('forms.MB')
        })
        return false;
      }
    } else {
      // this.fileTypeError = true;
      Swal.fire({
        icon: 'error',
        text: this.translate.instant('forms.InvalidFile')
      })
      return false;
    }
    return true;
  }
  fileType(fileName: string): any {
    const extension = fileName.split('.')?.pop()?.toLowerCase();
    switch (extension) {
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      default:
        return false;
    }
  }
}
